import { SetStateAction } from "react";
import { useNavigate } from "react-router-dom";
import { trackEvent } from "utils/analytics";

const HeaderSubTab = ({
  tabs,
  setIsOpenSubTab,
}: {
  tabs: any;
  setIsOpenSubTab: React.Dispatch<SetStateAction<boolean>>;
}) => {
  const navigate = useNavigate();

  const maxTabLength = Math.max(...(tabs?.map((tab: any) => tab.subTabs?.length || 0) || [0]));

  const getBannerMarginTop = () => {
    if (maxTabLength > 8) {
      const overlap = Math.min((maxTabLength - 8) * 20, 100);
      return `-${overlap}px`;
    }
    return "24px";
  };

  const linkToSubTab = (subTab: any) => {
    subTab.cate_cd ? navigate(`/post?cate=${subTab.cate_cd}`) : navigate(subTab.url);
    setIsOpenSubTab(false);
  };

  return (
    <nav
      className="header-sub-tab-container bg-white shadow-header pt-4 pb-5 animated-header"
      onMouseEnter={() => setIsOpenSubTab(true)}
      onMouseLeave={() => setIsOpenSubTab(false)}
    >
      <div className="max-w-[1200px] mx-auto">
        <div className="flex justify-around text-sm">
          {tabs.map(
            (tab: {
              label: string;
              value: string;
              width: number;
              subTabs: {
                cate_name: string;
                value: string;
                url: string;
              }[];
            }) => {
              return (
                <div
                  key={tab.value}
                  style={{ width: tab.width }}
                  onClick={() => trackEvent("Hover Sub Tab Click", { type: tab.value })}
                  className="relative"
                >
                  <div className="flex flex-col space-y-3 text-gray-600">
                    {tab.subTabs.map((subTab) => {
                      return (
                        <div
                          onClick={() => linkToSubTab(subTab)}
                          className="whitespace-nowrap text-secondary-900 font-normal text-sm leading-5 cursor-pointer hover:text-primary-800"
                          key={subTab.cate_name}
                        >
                          {subTab.cate_name === "AI 임상검색" ? (
                            <div className="flex items-center">
                              <img src="/img/ai/icon-badge-gradient.svg" className="w-4 h-4 mr-1" />
                              {subTab.cate_name}
                            </div>
                          ) : (
                            subTab.cate_name
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            },
          )}
        </div>
        {/* Promotional Banner */}
        <div
          onClick={() => {
            trackEvent("Banner Click", { origin: "hover-menu" });
            window.location.href = "https://moreden.co.kr/chicruiting/company/people";
          }}
          className="flex justify-center relative z-10"
          style={{ marginTop: getBannerMarginTop() }}
        >
          <img src="/img/hover-menu-banner.png" className="rounded-xl w-[380px]" />
        </div>
      </div>
    </nav>
  );
};

export default HeaderSubTab;
